const __WEBPACK_NAMESPACE_OBJECT__ = SharedDependencies.MobX['org_hub_shell'];